module.exports = __webpack_public_path__ + "static/media/containers.6be55b50.svg";